<template>
	<TableView v-if="showTableView" :col="columns" :getData="getData" :Options="{tblClass:'eachThree table-striped table-bordered'}" />           
</template>
<script>
import common from '@/assets/js/common.js';
import { mapActions } from 'vuex';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['report_date', 'account_numbers'],
  data(){
  	return {
      showTableView: false,
      res: {},
      columns: (() => {
        const cols = [
          
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          if(!this.can_view_field('report', col.nested?col.nested:col.field) && col.title != 'Operation') col.visible = false;
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  mounted() {
      if(this.account_numbers != null){
        var filter = {};
        this.changeBodyLoading(true);
        if(this.account_numbers.filter(val => val == 'ALL').length == 0)
          filter['account_number']  = this.account_numbers.join(',');
        let uri = 'stock_holding_analysis?report_date='+this.report_date[1]+'&filter='+JSON.stringify(filter);
        this.call_axios(uri).then(res => {
            this.res = res;
            this.columns = [
              { title: 'Account Number', field: 'account_number', visible: 'true',thClass: "leftfixed", tdClass: "leftfixed", tdStyle: {padding: "0.8rem !important"}},
            ];
            Object.keys(res.response.data.summary).forEach((v) => {
                //this.columns[0].push({title: v+' HOLDING ANALYSIS', field: v, thSpan: 3, thClass: 'text-center'});
                this.columns.push({ title: v+' SETTLED', field: v, nested: 'settled_quantity', visible: 'true', tdComp: 'Number', 'floatLength': 2},{ title: v+' PENDING', field: v, nested: 'pending_quantity', visible: 'true', tdComp: 'Number', 'floatLength': 2},{ title: v+' TOTAL', field: v, nested: 'total_quantity', visible: 'true', tdComp: 'Number', 'floatLength': 2});
            })
            this.showTableView = true;
            this.changeBodyLoading(false);
        });
      }
  },
  methods: {
    ...mapActions('layout', ['changeBodyLoading']),
    async getData(query, filter) {
      return this.res;
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>